import React, { Fragment } from 'react';
import userPlaceholder from '../../images/user-placeholder.png';

export const Avatar = ({ size = 'size-14', src, className = '' }) => {
  return (
    <>
      <span id="form-avatar" className={`inline-flex ${size} items-center justify-center rounded-full ${className}`}>
        {!src || src === '' ? (
          <img src={userPlaceholder} alt="User avatar placeholder" className="h-full w-full rounded-full" />
        ) : (
          <img src={src} alt="avatar" className="rounded-full" />
        )}
      </span>
    </>
  );
};
